import { Trans } from '@lingui/macro';
import React from 'react';

/**
 * GraphQL returns boolean flags for some attributes.
 * This helper component allows the values to be localized during PDF
 * generation.
 * @param {object} props
 * @param {boolean | undefined | null} props.value
 * @param {boolean} [props.noContentMeansNo=false]
 * @returns
 */
export default function convertBooleanToYesNo({
  value,
  noContentMeansNo = false,
}) {
  if (typeof value === 'undefined' && !noContentMeansNo) return null;
  if (value === null && !noContentMeansNo) return null;
  return value ? <Trans>Yes</Trans> : <Trans>No</Trans>;
}
